export const NEW_BIGEXPENSE = 'NEW_BIGEXPENSE';
export const EDIT_BIGEXPENSE = 'EDIT_BIGEXPENSE';